import { render } from "./SeasonCards.vue?vue&type=template&id=067e1136&scoped=true"
import script from "./SeasonCards.vue?vue&type=script&lang=js"
export * from "./SeasonCards.vue?vue&type=script&lang=js"

import "./SeasonCards.vue?vue&type=style&index=0&id=067e1136&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067e1136"]])

export default __exports__